import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {count: 0, houseInfo: null},
    mutations: {
        increment(state,type) {
            state.count= type
            localStorage.setItem('fromType', type);
        },
        inHouseInfo(state, info) {
            state.houseInfo = info
            localStorage.setItem('houseInfo', JSON.stringify(info));
        }
    },


    actions: {
        incrementAsync({commit}) {
            setTimeout(() => commit('increment'), 1000)
        }
    },
    getters: {
        increment: state => state.count,
        inHouseInfo: (state) => {
            return state.houseInfo;
        }
    }
});
